import React, { ReactNode, useEffect, useState } from 'react';
import { Outlet, useSearchParams } from 'react-router-dom';
import { Enviroment } from '@shared/enums/EnvironmentNames';
import { requestCustomToken } from '@modules/App/api/requestCustomToken';
import { EMAIL_DOMAIN } from '@shared/consts/constants';
import { getCurrentUser } from '@modules/App/redux/user/actions';
import { useDispatch } from 'react-redux';
import { getCustomAuth, isCustomTokenExpired, setCustomAuth } from '@shared/helpers/auth';

interface Props {
  children?: ReactNode;
}

export const RoutesWrapper: React.FC<Props> = ({ children }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const isProdEnv = process.env.REACT_APP_ENV === Enviroment.Production;
  const tokenFromParams = searchParams.get('fakeDevUser');
  const customAuth = getCustomAuth();
  const isCustomAuthExpired = isCustomTokenExpired(new Date(customAuth?.expiresIn || ''));
  const shouldStartCustomLogin = !isProdEnv && Boolean(tokenFromParams || (customAuth?.email && isCustomAuthExpired));
  const [isCustomLoginLoading, setIsCustomLoginLoading] = useState(shouldStartCustomLogin);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isProdEnv) {
      return;
    }
    let email = '';
    if (tokenFromParams) {
      const normalizedEmailDomain = EMAIL_DOMAIN?.replace(/^@+/, '');
      email =
        tokenFromParams.includes('@') || !normalizedEmailDomain
          ? tokenFromParams
          : `${tokenFromParams}@${normalizedEmailDomain}`;
    }
    if (customAuth?.email && isCustomAuthExpired) {
      email = customAuth.email;
    }
    if (!email) {
      return;
    }
    setIsCustomLoginLoading(true);

    requestCustomToken({ email, device: navigator.userAgent })
      .then((data) => {
        setCustomAuth({ data, email });
        if (tokenFromParams) {
          setSearchParams('');
        }
        dispatch(getCurrentUser());
      })
      .finally(() => {
        setIsCustomLoginLoading(false);
      });
  }, [customAuth?.email, isCustomAuthExpired, isProdEnv, dispatch, setSearchParams, tokenFromParams]);

  if (isCustomLoginLoading) {
    return null;
  }

  return (
    <>
      <div>{children}</div>
      <Outlet />
    </>
  );
};
